export default __webpack_public_path__ + "static/media/Trockenbau-und-akustikdecken.f2b24a32.jpg";